import Button from "@mui/material/Button"
import Grid from "@mui/material/Grid"
import React, { useContext, useEffect, useState } from "react"
import ExistingScorecardViewModel from "../ViewModels/ExistingSorecardViewModel";
import { APIContext } from "src/components/Contexts/APIContext"
import { MsalContext } from "src/components/Contexts/MsalContext"
import { formatDate } from "src/components/Utilities/UtilityMethods";

interface IExistingScorecardActionButtonsProps {
    scorecard: ExistingScorecardViewModel;
    loadScorecard: (completeId: number) => void;
    viewPDF: (completeId: number) => void;
    checkExistingScorecards: (firstLoad: boolean) => void;
    agentView?: boolean
}
export default function ExistingScorecardActionButtons(props: IExistingScorecardActionButtonsProps) {
    const { msalFetch } = useContext(MsalContext)
    const { get, loading, showMessage } = useContext(APIContext);
    const [client, setClient] = useState<string | null>(null);

    useEffect(() => {
        getClient();
    }, [])

    const getClient = () => {
        get('PDFGenerator', `GetClient?callRefId=${props.scorecard.callRefId}`, (data) => setClient(data))
    }

    const pdfDownload = () => {
        msalFetch(`api/PDFGenerator/CreateScorecardPDF?completeId=${props.scorecard.completeId} `)
            .then(response => response.blob())
            .then(data => {
                console.log(data)
                if (data.type === "application/problem+json") {
                    console.log('error', 'An internal server error occured');
                    return;
                }
              
                var dateTime = new Date();
                var formattedTime = formatDate(dateTime);
                var url = window.URL.createObjectURL(data);
                var a = document.createElement('a');
                a.href = url;
                a.download = client + "_" + formattedTime + "_" + props.scorecard.completeId + ".pdf";
                document.body.appendChild(a);
                a.click();
                a.remove();
            })
            .catch(e => {
                console.log(e);
            });
    }

    const reIssueFeedback = () => {
        get('Feedback', `ReIssueFeedback?completeId=${props.scorecard.completeId}`, () => {
            props.checkExistingScorecards(false);
            showMessage("success", "Feedback Re-issued")
        })
    }

    return (
        <Grid container spacing={1} justifyContent="center">
            {!props.agentView &&
                <Grid>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                            if (!props.scorecard.type.includes("AI-Monitoring")) {
                                props.loadScorecard(props.scorecard.completeId);
                            } else {
                                props.viewPDF(props.scorecard.completeId);
                            }
                        }}
                        disabled={loading}>
                        Load Scorecard
                    </Button>
                </Grid>
            }
            {props.agentView &&
                <Grid>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => props.viewPDF(props.scorecard.completeId)}
                        disabled={loading}>
                        View PDF
                    </Button>
                </Grid>
            }
            {!props.agentView &&
                <Grid>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => pdfDownload()}
                        disabled={loading}>
                        Download PDF
                    </Button>
                </Grid>
            }
            {
                props.scorecard.type === "Redress" && !props.agentView
                && props.scorecard.feedbackStatus === "Feedback Accepted" &&
                <Grid>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => reIssueFeedback()}
                        disabled={loading}>
                        Re-issue Feedback
                    </Button>
                </Grid>
            }
        </Grid>
    );
}